import PropTypes from 'prop-types';

import { Header, Image, Button } from 'semantic-ui-react';

import { useBreakpoints } from '$app/common/utils/mediaQueries';

const ErrorPage = ({
  illustrationUrl,
  title,
  description,
  buttonProps,
  secondaryButtonProps,
  heightOffest,
}) => {
  const { isXsDown } = useBreakpoints();

  const hasButtonProps =
    typeof buttonProps === 'object' && Object.keys(buttonProps).length;
  const hasSecondaryButton =
    typeof buttonProps === 'object' && Object.keys(secondaryButtonProps).length;

  return (
    <div
      css={{
        margin: `${heightOffest} 20px 0`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Image size={isXsDown ? 'medium' : 'large'} src={illustrationUrl} />

      <Header size={isXsDown ? 'large' : 'huge'}>{title}</Header>

      {description ? (
        <p css={{ marginTop: 20, lineHeight: 1.5 }}>{description}</p>
      ) : null}

      <div css={{ marginTop: 20 }}>
        {hasButtonProps ? (
          <Button
            css={{ '&&.ui.button': { background: '#6C2D8A', color: '#fff' } }}
            onClick={buttonProps?.onClick}
          >
            {buttonProps.label}
          </Button>
        ) : null}

        {hasButtonProps && hasSecondaryButton ? (
          <Button
            onClick={secondaryButtonProps?.onClick}
            css={{
              '&&.ui.button': {
                marginLeft: 5,
                background: '#6C2D8A',
                color: '#fff',
              },
            }}
          >
            {secondaryButtonProps.label}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

ErrorPage.defaultProps = {
  description: null,
  buttonProps: {},
  secondaryButtonProps: {},
  heightOffest: '10vh',
};

ErrorPage.propTypes = {
  illustrationUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  buttonProps: PropTypes.shape({
    onClick: PropTypes.func,
    label: PropTypes.string,
  }),
  secondaryButtonProps: PropTypes.shape({
    onClick: PropTypes.func,
    label: PropTypes.string,
  }),
  heightOffest: PropTypes.string,
};

export default ErrorPage;
